<template>
    <c-select
        :label="label"
        :horizontal="true"
        :options="availableAddresses"
        :required="false"
        v-model="pickUpAddress"
        ValueName=""
        :DisplayName="$filter.address"
        :name="name"
        @change="$refs.zipcodeAddress.foundZipcode=true"
    />

    <CZipcodeAddress
        :name="name"
        label="Postcode en hnr."
        :sublabel="label"
        :horizontal="true"
        :zipcode="pickUpAddress.zipcode"
        :number="pickUpAddress.number"
        :street="pickUpAddress.street"
        :city="pickUpAddress.city"
        :addition="pickUpAddress.addition"
        :locationName="pickUpAddress.name"

        @input="pickUpAddress=$event"
        ref="zipcodeAddress"
    />
</template>

<script>
import CZipcodeAddress from "@components/ZipcodeAddress.vue";
import Form from '@mixins/Form';

export default {
    mixins: [Form],
    components: {CZipcodeAddress},
    props: {
        modelValue: Object,
        addresses: {
            type: Array,
            required: true,
        },
        label: String,
        name: {
            type: String,
            required: true,
        }
    },
    computed: {
        availableAddresses() {
            return this.addresses.map(({name, street, number, addition, zipcode, city}) => ({name, street, number, addition, zipcode, city}));
        },
        pickUpAddress: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value)
            }
        },
    },
}

</script>